// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2pJir","addWidgetButton":"Header_addWidgetButton__ynyL4","dashboardTabs":"Header_dashboardTabs__2AY_n","active":"Header_active__4bgiK"};